module.exports = __webpack_public_path__ + "img/2x.ec0ad26.jpg";